import routes from 'pages/routes';
import Vue from 'vue';
import VueRouter from 'vue-router';
import { sync } from 'vuex-router-sync';
import Store from 'store';
import isAuthenticated from './isAuthenticated';

Vue.use(VueRouter);

const Router = new VueRouter({
    routes,
});

Router.beforeResolve(isAuthenticated);

sync(Store, Router);

export default Router;



// WEBPACK FOOTER //
// ./src/router/index.js